import { theme } from "@chakra-ui/core";
import styledIn, { CreateStyled } from "@emotion/styled";

export const customTheme = {
  ...theme,
  colors: {
    ...theme.colors
    // Go to https://smart-swatch.netlify.com/ to easily generate a new color
    // palette.
  }
};

export type Theme = typeof customTheme;
export const styled = styledIn as CreateStyled<Theme>;
